<app-page-artwork [section]="section"></app-page-artwork>
<div class="w-100 bkcolor-cjc-header textaure-wrapper">
    <div class="px-5 py-1">
        <div class="about-section container-lg">
            <div class="row align-items-center my-5">
                <div class="col-12 col-lg-4  offset-lg-1 ">
                        <img src="assets\imgs\New Website banners\CJC About Us - Cat On Boat.webp"  class="img-fluid d-flex m-auto" alt="Cat On Boat">
                </div>
                <div class="col-12 col-lg-6  section d-lg-block d-none">
                    <h2 >Your Go-To </h2>
                    <div class="d-flex">
                        <h2>Hub</h2>
                        <strong style="margin-left: 20px;" >{{ yourGoToHubDesc }}</strong>
                    </div>
                </div>
                <div class="col-12 col-lg-5 section d-block d-lg-none">
                    <h2 >Your Go-To Hub </h2>
                    <strong >{{ yourGoToHubDesc }}</strong>
                </div>
            </div>
            <!-- Start of ALL ABOUT THE MUSIC section -->
             <div class="row my-5 align-items-center">
                <div class="col-12 col-lg-5 d-block d-lg-none">
                    <div class="position-relative">
                        <img src="assets\imgs\New Website banners\CJC About Us - Peacock.webp" class="img-fluid d-flex m-auto" alt="CJC About Us">
                    </div>
                </div>
                <div class="col-12 col-lg-4 section">
                    <div class="rotate-left">
                      <h2 style="line-height: 1;">All About <br> The Music</h2>
                    </div>
                 </div>
                <div class="col-12 col-lg-8 section">
                    <img src="assets\imgs\New Website banners\CJC About Us - Peacock.webp" class="img-fluid float-right peacock-image d-lg-block d-none" alt="CJC About Us" >
                    <strong>CJC’s stage has witnessed the rise of many fresh talents, and has regularly hosted the finest live acts in town as well as exciting international artists. With the opening of CJC’s sister venue-Cairo Jazz Club 610 (CJC 610, Sheikh Zayed), this gave room for even bigger acts, club nights hosting some of the most renowned DJs in the world, and large-scale concerts. We make it our mission to tirelessly expose new talent and present them with the space and opportunity to grow. Simultaneously, we are adamant on catering to all tastes and providing a variety of events and genres for our guests to experience, everyday of the week.</strong>
                </div>
            </div>

            <!-- End of ALL ABOUT THE MUSIC section -->

            <div class="row my-5">
                <div class="col-12 col-lg-4 offset-lg-1">
                    <div class="position-relative">
                        <img src="assets\imgs\New Website banners\CJC About Us - Classic Cat.webp" class="img-fluid d-flex m-auto" alt="CJC About Us - Classic Cat">
                    </div>
                </div>
                <div class="col-12 col-lg-7 ">
                    <div class="row">
                        <div class="col">
                            <div class="row ">
                                <div class="col section">
                                    <h2 class="d-lg-flex d-none justify-content-center">THE <br> PHILOSOPHY</h2>
                                    <h2 class="d-block d-lg-none">THE PHILOSOPHY</h2>
                                    <strong style="font-size: 18px;"  [ngStyle]="{'text-align':mobView ? 'center' : '' , 'font-size' :!mobView ? '18px' : ''  }">The philosophy that has kept us going thus far is simpler than you would think: we serve good moods, and that is precisely what is on the menu every day of the week. 
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row my-5 align-items-center" style="row-gap: 20px;">
                <div class="col-lg-7 col-12 mob-img d-flex d-lg-none">
                    <img class="img-fluid" src="assets\imgs\STAGE HISTORY 01.png" alt="STAGE HISTORY">
                </div>

                <div class="col-lg-4 col-12 offset-lg-1 section ">
                    <h2 class="mt-5" style="line-height: 1;">stage<br> history</h2>
                </div>
                <div class="col-lg-7 col-12  d-lg-block d-none">
                    <img class="img-fluid" src="assets\imgs\STAGE HISTORY 01.png" alt="STAGE HISTORY">
                </div>
                <div class="col-lg-11 col-12 offset-lg-1 section ">
                    <strong>From the very beginning, a fundamental aspect of the Cairo Jazz Club experience has always been its stage, instrumental in the evolution of Cairo’s independent music scene. Cairo Jazz Club has always provided a platform for fresh talent, leading to why some of the city’s top bands and budding artists were born on that stage. As time passed, CJC and CJC 610 have evolved into venues that regularly host the region's finest live acts, renowned international bands and some of the most coveted DJs in the world, making the two venues rightly recognized as the “capitals” of live music and club nights in the city.
                    Below is a brief list of some of the talents that have been on CJC & CJC 610’s stage: </strong>
                    <div class="row my-3">
                        <div class="col-md-4 col-12 center d-flex flex-column gap" >
                            <strong class="artist-font"> Internationally Acclaimed Artists <br> </strong>
                            <div class="w-100 mb-2"></div>
                            <strong> Ali Gatie <br>Balthazar <br>Carles Benavent <br> Cigarettes After Sex <br> Ghostly Kisses
                                <br> Homeshake <br> Jaakko Eino Kalevi <br> Jay Rodriguez <br> Michiel Bortslap <br> 
                                Molly Nillson <br> Monica Passos <br> Saint Levant <br> Tamino <br> Vavamuffin
                            </strong>
                        </div>
                        <div class="col-md-4 col-12 center d-flex flex-column gap">
                            <strong class="artist-font"> Regional Artists <br> </strong>
                            <div class="w-100 mb-2"></div>
                            <strong> 47 Soul<br>
                                Akher Zapheer <br>Alaa Wardi <br>Al Nather <br>Alsarah & The Nubatones <br>
                                Autostrad<br>Aziz Maraka<br>Bu Kolthoum <br>
                                El Far3i <br> Emel Mathlouthi <br>Ghalia Ben Ali <br>
                                Ilham Madfai <br>Jadal <br>Mashrou’ Leila <br>Oum <br>Shabmouri 
                                <br>Souad Massi <br>Tania Saleh<br>The Synaptik <br>
                                 Who Killed Bruce Lee <br>Zaid Khaled <br>Zeid Hamdan <br>
                            </strong>
                        </div>
                        <div class="col-md-4 col-12 center d-flex flex-column gap">
                            <strong class="artist-font"> Established Egyptian Artists/ Bands<br></strong>
                            <div class="w-100 mb-2"></div>
                            <strong> Abyusif <br>
                                Cairokee <br>
                                Dina El Wedidi <br> Egyptian Project <br> Ehab Tawfik <br> El Waili <br> Fathy Salam <br> Hamid Al Shaeri <br>
                                Hisham Abbas <br>
                                Islam Chipsy <br>
                                Mariam Saleh <br>
                                Marwan Pablo <br>
                                Marwan Moussa <br>
                                Massar Egbari <br>
                                Molotof <br>
                                Moustafa Amar <br>
                                Perrie <br>
                                Sharmoofers <br>
                                Wegz <br>
                                Wust El Balad <br>
                                Yehya Khalil <br>
                            </strong>
                        </div>
                                <div class="col-lg-3 col-md-4 col-12 center d-flex flex-column gap">
                                    <strong class="artist-font"> International DJs <br></strong>
                                    <div class="w-100 mb-2"></div>
                                    <strong> Agents of Time <br>

                                        Ame <br>
                                        
                                        ARTBAT <br>
                                        
                                        Coeus <br>
                                        
                                        Colyn <br>
                                        
                                        Giorgia Anguili <br>
                                        
                                        Innellea <br>
                                        
                                        Kevin De Vries <br>
                                        
                                        Marino Canal <br>
                                        
                                        Stephan Jolk <br>
                                        
                                        Undercatt <br>
                                        
                                        Whomadewho
                                    </strong>
                                    </div>
                                    <div class="col-lg-7 col-md-8 col-12 offset-lg-1 mob-img">
                                        <img src="assets\imgs\STAGE HISTORY 02.png" alt="STAGE HISTORY" class="img-fluid">
                                    </div>

                            </div>
                        </div>
                    </div>


            <div class="row my-5 align-items-center" style="row-gap: 20px;">
                <div class="col-lg-3 col-12 mob-img">
                    <img src="assets\imgs\BEHIND THE ART 01.png" alt="STAGE THE ART">
                </div>
                <div class="col-12 col-lg-4 section">
                    <div class="rotate-right">
                      <h2 style="line-height: 1; ">behind <br> the art</h2>
                    </div>
                 </div>

                 <div class="col-lg-3 section ">
                    <strong>Cairo Jazz Club was very lucky to work with different creative talents over the years. Known for our unique custom-made drawings, mystical interior design and authentic designs, CJC would like to commend the imaginative minds behind our identity and character that followed.</strong>
                 </div>
                 <div class="col-lg-8 col-12 offset-lg-1 d-flex flex-column section " style="row-gap: 20px;">
                    <strong>
                        Amr Qenawi: Current Head of Graphic Design & Art Direction <br>                                                                                      
Although his line of work requires versatility in style, CJC’s resident designer Qenawi’s unique artistic identity is embedded in all aspects of his CJC designs. Our creative and easily distinguishable digital identity and prints all show the admirable objectivity in his work. He plays a huge role in creating and shaping CJC’s digital identity.
Amr draws inspiration from the likes of illustrators Eric Petersen and Patrick Nagel.
                    </strong>
                    <strong>
                        Karine Ghaly: Artist responsible for our unique illustrations/characters <br>
If you ever wondered about the creative mastermind behind the illustrations that inspired everything from our logo to our tables and façade, look no further than artist Karine Ghaly. Karine used her love of Egypt and music to help influence the logo and illustrations for Cairo Jazz Club. By combining her creative imagination with a modern twist, she was able to create a carefree identity to match CJC’s ambiance.
                    </strong>
                    <strong>
                        Meline Ghaly: Artist behind the masks <br>
The silver colored masks hanging on our walls have become a true CJC trademark since day one. Meline Ghaly is the artist/sculptor behind the masks, she made them for Cairo Jazz Club when the venue first opened under new ownership in 2001. The masks are made of clay and painted with acrylic paint. When asked about them, Meline said “I don’t see them as masks, but as the true essence of human emotions behind the masks.” Meline is still actively making new and fascinating clay creations to this day.
                    </strong>
                 </div>
                 <div class="col-lg-1 d-flex align-items-center offset-lg-1 justify-content-center">
                    <img src="assets\imgs\BEHIND THE ART 02.png" class="img-fluid" alt="cjc-eye-icon">
                 </div>
            </div>
        </div>
    </div>

    <div class="container-lg mt-1 pb-4">
        <div class="row">
            <div class="col">
                <div class="embed-responsive embed-responsive-16by9 m-0 mb-3">
                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/aDmUgxwcwAM?controls=1&showinfo=0&rel=0&autoplay=0&loop=1&mute=1"
                        frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row my-5 d-sm-flex d-none">
        <div class="col"></div>
    </div>
    <div class="row my-5 ">
        <div class="col"></div>
    </div> -->
    <!-- <div class="p-2">
        <div class="container">
            <div class="row d-sm-flex d-none">
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-6">
                            <i class="cjc-icon icon-9x icon-icons-white-02 "></i>
                        </div>
                        <div class="col-6">
                            <div class="row my-5">
                                <div class="col"></div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="mt-4 rotate-right">
                                        <h1 style="font-size: 50px;" class=" font-bold ">STAGE HISTORY</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 ">
                    <p>FROM THE GET GO, A FUNDAMENTAL ESSENTIAL TO THE CAIRO JAZZ
                        CLUB EXPERIENCE WAS ITS STAGE, INSTRUMENTAL IN THE EVOLUTION OF CAIRO’S INDEPENDENT MUSIC SCENE.
                        CAIRO JAZZ CLUB
                        HAS ALWAYS PLATFORMED FRESH TALENT LEADING TO WHY MOST
                        OF THE CITY’S TOP END BANDS SUCH AS WUST EL BALAD, THE RIFF
                        BAND AND SCREWDRIVER WERE BORN ON THAT STAGE. THE STAGE
                        UNTIL NOW IS A REGULAR HOST TO THE FINEST LIVE ACTS IN TOWN
                        AND THE CLUB IS RIGHTLY RECOGNIZED AS THE “CAPITAL” OF LIVE
                        MUSIC IN THE CITY.</p>
                </div>
            </div>
            <div class="d-flex d-block d-sm-none" style="flex-direction:column; text-align: center;">
                <h2>STAGE HISTORY</h2>
                <p style="font-size: 10px" class="text-center">FROM THE GET GO, A FUNDAMENTAL ESSENTIAL TO THE CAIRO JAZZ CLUB EXPERIENCE WAS ITS STAGE, INSTRUMENTAL IN THE EVOLUTION OF CAIRO’S INDEPENDENT MUSIC SCENE. CAIRO JAZZ CLUB HAS ALWAYS PLATFORMED FRESH TALENT 
                    LEADING TO WHY MOST OF THE CITY’S TOP END BANDS SUCH AS WUST EL BALAD, 
                    THE RIFF BAND AND SCREWDRIVER WERE BORN ON THAT STAGE. THE STAGE 
                    UNTIL NOW IS A REGULAR HOST TO THE FINEST LIVE ACTS IN TOWN AND THE 
                    CLUB IS RIGHTLY RECOGNIZED AS THE “CAPITAL” OF LIVE MUSIC IN THE CITY</p>
            </div>
        </div>
        <div class="row my-5">
            <div class="col"></div>
        </div>
        <div class="row my-5">
            <div class="col"></div>
        </div>
    </div> -->
</div>